/**
 * Whether the Edit page has a sticker to offer.
 *
 * - `available` — show the editor.
 * - `none`      — nothing to edit: skip the page (through its Continue, which still
 *                 prints and uploads the strip).
 * - `pending`   — stickers are configured but the catalogue is not in yet; wait.
 *
 * Decided from the sticker list alone. It must not wait on the global asset
 * counter, which also counts frame, filter and background images and does not
 * reliably reach its total.
 *
 * There is no brush-only mode: the project settings are `enabled`, `editTimeout`
 * and `stickerIds`, so a page with no sticker is a page with nothing configured.
 */
export type EditStickerAvailability = 'available' | 'none' | 'pending'

export function resolveEditStickerAvailability({
  stickerIds,
  availableStickerCount,
  catalogLoaded
}: {
  /** `pages.edit.settings.stickerIds` */
  stickerIds: readonly string[] | undefined
  /** Configured stickers found in the loaded catalogue (what the grid shows). */
  availableStickerCount: number
  /** The config store's `stickersLoaded`. */
  catalogLoaded: boolean
}): EditStickerAvailability {
  if (!stickerIds || stickerIds.length === 0) return 'none'
  if (availableStickerCount > 0) return 'available'
  // Configured ids that the catalogue does not return were deleted or deactivated.
  return catalogLoaded ? 'none' : 'pending'
}
